import * as ActionTypes from 'constants';

const client_incidents = (state = {
  incidents: [],
  recent_impacts: [],

  selected_incident: null,
  downloading_incidents: false,

  show_create_incident: false,
  generating_report : false,
  deleting_report_pdfs : false,
  show_new_report_prompt : false,
  report_link : '',

  offset: 0,
  size: 50,
  total: 0,
}, action) => {
  const { payload, type } = action;
  const { incidents, recent_impacts } = state;
  let index;

  switch (type) {
    case ActionTypes.START_CREATE_INCIDENT:
      return { ...state, show_create_incident: true };
    case ActionTypes.HIDE_CREATE_INCIDENT:
      return { ...state, show_create_incident: false };
    case ActionTypes.PREVIEW_INCIDENT:
      return { ...state, selected_incident: action.payload.incident._id };
    case ActionTypes.FETCH_CLIENT_INCIDENTS:
      return { ...state, downloading_incidents: true };
    case ActionTypes.RECEIVE_CLIENT_INCIDENTS:
      return { ...state,
        downloading_incidents: false,
        incidents: action.payload.incidents.map(i => {
          if(i.adjuster_report_pdfs && i.adjuster_report_pdfs.length > 0) {
            return {...i, adjuster_report_pdfs : i.adjuster_report_pdfs.map(file => {
              return {idx : null, file : file, selected : false}
            })}
          }
          else {
            return i
          }
        })};
    case ActionTypes.UPDATE_INCIDENT:
      return { ...state,
        incidents: incidents.map((incident) => (incident._id == payload.incident._id) ? {...payload.incident} : incident) };
    case ActionTypes.ADD_CLIENT_INCIDENT:
      return { ...state,
        incidents: [payload.incident, ...incidents.filter(({ _id }) => _id != payload.incident._id)] };
    case ActionTypes.RECEIVE_CLIENT_RECENT_IMPACTS:
      return { ...state, recent_impacts: payload.impacts };
    case ActionTypes.ADD_INCIDENT_REPORT_PDF :
      index = state.incidents.findIndex(i => i._id === state.selected_incident)
      if(index !== 1) {
        return {...state,
          incidents : [
            ...state.incidents.slice(0, index),
            {...state.incidents[index],
              adjuster_report_pdfs : (
                state.incidents[index].adjuster_report_pdfs ?
                [...state.incidents[index].adjuster_report_pdfs, {file : payload}] :
                [paylad]
              )
            },
            ...state.incidents.slice(index + 1)
          ]
        }
      }
    case ActionTypes.TOGGLE_INCIDENT_REPORT_SELECTED :
      index = state.incidents.findIndex(i => i._id === state.selected_incident)
      if(index !== -1) {
        let max_selected_idx;
        if(state.incidents[index].adjuster_report_pdfs && state.incidents[index].adjuster_report_pdfs.filter(p => p.idx != null).length > 0)
          max_selected_idx = Math.max(...state.incidents[index].adjuster_report_pdfs.filter(p => p.idx != null).map(p => p.idx))
        else
          max_selected_idx = 0;

        let report_index = state.incidents[index].adjuster_report_pdfs.findIndex(r => r.file._id === payload.id)
        if(report_index !== -1) {
          let current_incident = state.incidents[index]
          let current_report = state.incidents[index].adjuster_report_pdfs[report_index]

          if(payload.val === true) {
            return {
              ...state,
              incidents : [
                ...state.incidents.slice(0, index),
                {...current_incident, adjuster_report_pdfs : [
                  ...current_incident.adjuster_report_pdfs.slice(0, report_index),
                  {...current_report, selected : true, idx : (max_selected_idx + 1)},
                  ...current_incident.adjuster_report_pdfs.slice(report_index + 1 )
                ]},
                ...state.incidents.slice(index + 1)
              ]
            }
          }
          else {
            return {
              ...state,
              incidents : [
                ...state.incidents.slice(0, index),
                {...current_incident, adjuster_report_pdfs : [
                  ...current_incident.adjuster_report_pdfs.slice(0, report_index).map(r => {
                    if(r.idx != null && current_report.idx != null && r.idx > current_report.idx)
                      return {...r, idx : r.idx - 1}
                    else
                      return r
                  }),
                  {...current_report, selected : false, idx : null},
                  ...current_incident.adjuster_report_pdfs.slice(report_index + 1).map(r => {
                    if(r.idx != null && current_report.idx != null && r.idx > current_report.idx)
                      return {...r, idx : r.idx - 1}
                    else
                      return r
                })
              ]},
              ...state.incidents.slice(index + 1),
            ]
          }
        }
      }
    }
  case ActionTypes.DELETE_REPORT_PDFS :
    return {...state, incidents : 
      state.incidents.map(incident => {
        if(incident._id === state.selected_incident) {
          return {...incident, adjuster_report_pdfs : incident.adjuster_report_pdfs.filter(p => !p.selected)}
        }
        else {
          return {...incident}
        }
      })
    }
  case ActionTypes.TOGGLE_GENERATING_REPORT :
    return {...state, generating_report : (payload !== undefined ? payload : !state.generating_report)}
  case ActionTypes.PROMPT_NEW_REPORT_DOWNLOAD :
    return {...state, show_new_report_prompt : true, report_link : payload}
  case ActionTypes.HIDE_NEW_REPORT_PROMPT :
    return {...state, show_new_report_prompt : false, report_link : ''}
  case ActionTypes.TOGGLE_DELETING_REPORT_PDFS :
    return {...state, deleting_report_pdfs : (payload !== undefined ? payload : !state.deleting_report_pdfs)}
  default:
    return state;
  }
}

export { client_incidents };



// WEBPACK FOOTER //
// ./src/common/reducers/client_incidents.js